var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comButton"},[_c('button',{class:['comButton_btn' , _vm.type ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.btnText))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }